import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo1 from '../../../images/logo.png'
import Logo2 from '../../../images/logo.jpg'

export default function SignIn() {
    const navigate = useNavigate();
    // States for login
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    // States for checking errors
    const [error, setError] = useState('');
    
    // Handling the form submission
    const handleSubmit = (e) => {
        e.preventDefault();
            // Handling the login logic
            try {
                // Assuming you have the authenticate function
              navigate('/');
            } catch {
              setError('Invalid username or password');
            }
    };

    return (
      <div className='bg-white h-screen'>
        <div className="grid grid-cols-2 h-full bg-white">
        <div className='bg-black hidden lg:flex'>
            <img src={Logo2} className='w-full' alt=''/>
        </div>
        <div className="flex bg-white col-span-2 lg:col-span-1 min-h-full max-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-10 w-auto flex lg:hidden"
              src={Logo1}
              alt="Rokasa Collection"
            />
            <h2 className="mt-10 lg:mt-0 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Connectez-vous à votre compte
            </h2>
          </div>
  
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                  E-mail
                </label>
                <div className="mt-2">
                  <input
                    type="email"
                    name="email"
                    placeholder="nom@gmail.com" 
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    // required
                    className="block w-full bg-gray-50  rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
  
              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                  Mot de passe
                  </label>
                  <div className="text-sm">
                    <a href="#" className="font-semibold text-gray-900 hover:text-black">
                    Mot de passe oublié?
                    </a>
                  </div>
                </div>
                <div className="mt-2">
                  <input
                    type="password"
                    name="password"
                    placeholder="••••••••"
                    value={password} onChange={(e) => setPassword(e.target.value)}
                    // required
                    className="block w-full bg-gray-50 rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              {error && <p className='text-red-600 text-sm'>{error}</p>}

              <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input id="terms" aria-describedby="terms" type="checkbox" class="w-4 h-4 border text-black border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-gray-300  " required=""/>
                      </div>
                      <div class="ml-3 text-sm">
                        <label for="terms" className=" text-gray-500">Se souvenir de moi</label>
                      </div>
                </div>
  
              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                  Se connecter
                </button>
              </div>
            </form>
  
            <p className="mt-10 text-center text-sm text-gray-500">
            Vous n'avez pas de compte ? {' '}
              <Link to="/sign-up" className="font-semibold leading-6 text-black hover:text-gray-900">
              Créer un compte
              </Link>
            </p>
          </div>
        </div>
        </div>
      </div>
    )
  }
  